<template>
  <div>
    <div style="text-align: center;">
      <v-btn
        class="pt-3 pr-0"
        color="white"
        style="transform: scaleX(0.9);margin:-5px 8px 8px 8px"
        depressed
        @click="menuClick('/')"
      >
        <v-icon
          color="green lighten-8"
          size="30"
          left
          style="transform: scaleX(1.2);margin-top: -12px;"
          >fas fa-tree</v-icon
        >
        <span class="font-weight-black title pb-1 mb-1"
          >点字サークル「杉」</span
        >
      </v-btn>
      <!-- <div style="position: absolute;top: 0px;right: 0px;">
        <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          small
          class="mt-0"
          color="success"
          @click="$router.push('/mail')"
        >
          <v-icon small>far fa-envelope</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="mt-0"
          tile
          small
          outlined
          color="success"
          @click="$router.push('/mail')"
        >
          <v-icon left small>far fa-envelope</v-icon>お問い合わせ
        </v-btn>
      </div> -->
    </div>

    <v-row
      justify="space-around"
      class="mb-3"
      v-if="!$vuetify.breakpoint.xsOnly"
    >
      <v-menu
        offset-y
        v-for="(item, i) in items"
        :key="i"
        :open-on-hover="true"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="green lighten-2"
            dark
            v-on="on"
            style="border-radius: initial;    min-width: 180px;"
            >{{ item.text }}</v-btn
          >
        </template>
        <v-list>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            @click="menuClick(child.url)"
          >
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
    <v-img
      :src="image"
      class="white--text align-end page_title_image"
      @load="showTitle = true"
    >
      <span class="page_title sub">{{ pageInfo.subText }}</span>
      <br />
      <h1 class="page_title" v-if="showTitle">
        {{ pageInfo.text }}
      </h1>
    </v-img>
  </div>
</template>

<script>
export default {
  name: "Header",
  data: () => ({
    items: [],
    showTitle: false,
    pageInfo: {},
  }),
  watch: {
    $route(to) {
      this.showTitle = false;
      let info = {};
      this.$store.state.menuList.forEach((element) => {
        element.children.forEach((child) => {
          if (child.url == to.path) {
            info = child;
            return;
          }
        });
      });
      this.pageInfo = info;
    },
  },
  created() {
    let menu = this.$store.state.menuList.filter(function(object) {
      return object.menu == true;
    });
    this.items = JSON.parse(JSON.stringify(menu));
    this.pageInfo.image = "greenPhoto1.jpg";
    this.pageInfo.text = "点字サークル「杉」";
    this.pageInfo.subText = "埼玉県北葛飾郡杉戸町";
  },
  computed: {
    image: function() {
      if (!this.pageInfo.image) return "";
      return require("@/assets/" + this.pageInfo.image);
    },
  },
  methods: {
    isInternalLink(url) {
      return !/^https?:\/\//.test(url);
    },
    menuClick(url) {
      if (this.isInternalLink(url)) {
        if (this.$route.path !== url) {
          this.$router.push(url);
        }
      } else {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Yu Gothic";
  font-size: 18px;
}
.v-list-item__title,
.v-btn.v-size--default {
  font-size: 14px;
}
.v-list-item {
  min-height: 35px;
}
.v-responsive.page_title_image {
  text-align: right;
  max-width: 126%;
  margin-right: -12px;
  margin-left: -12px;
}
.page_title {
  font-size: 20px;
  margin-bottom: 10px;
  padding-right: 15px;
  text-align: right;
  line-height: 0.95em;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 0 0.1em #1b4925, 0 0 0.2em #1b4925, 0 0 0.3em #1b4925,
    0 0 0.6em #1b4925;
  filter: saturate(80%);
}
.sub {
  font-size: 14px;
  padding-right: 23px;
  font-weight: initial;
}
</style>
